import React from 'react';
import { Row, Col, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import IconIos from '../../../../static/img/icon-type-ios.png';
import IconAndroid from '../../../../static/img/icon-type-android.png';
import IconEdit from '../../../../static/img/icon-app-edit.png';
import IconEye from '../../../../static/img/icon-app-eye-fill.png';
import IconDelete from '../../../../static/img/icon-app-delete.png';
import BackgroundIhealth from '../../../../static/img/icon-app-background-ihealth.png';

const DateilsItemPage = (props) => {
    const navigate = useNavigate();
    React.useEffect(() => {

    }, [])
    function onStartAppHistory() {
        console.log(props.item)
        navigate('/developerCenter/apk/appHistoryList', {
            replace: false,
            state: {
                project: props.item,
            }
        })
    }

    return (
        <Button type='text' onClick={onStartAppHistory} style={{ backgroundColor: 'white', borderRadius: '10px', height: '500px', padding: '0px' }}>
            <div style={{ height: '500px', width: '380px' }}>
                <Row style={{ marginLeft: '30px' }}>
                    <Col span={12} style={{ marginTop: '30px' }}>
                        <Row >
                            <img className="icon" alt='' src={props.item.icon} style={{ display: props.item.icon === '' ? 'none' : '', height: '90px', width: '90px',borderRadius: '10px',  }} />
                            <div style={{ display: props.item.icon === '' ? '' : 'none', height: '90px', width: '90px', backgroundImage: `url(${BackgroundIhealth})`, backgroundSize: 'cover' }}>

                            </div>
                        </Row>

                    </Col>
                    <Col span={12} style={{ display: 'flex', justifyContent: 'right' }}>
                        <img style={{ height: '30px', width: '30px', }} src={props.item.platform === 'IOS'?IconIos:IconAndroid
                    } />
                    </Col>
                </Row>

                <Row style={{ fontSize: '20px', marginTop: '30px', marginLeft: '30px' }}>{props.item.projectName}</Row>


                <Row style={{ marginTop: '20px' }}>
                    <Col >
                        <div style={Styles.dateilsLeft}>{props.item.platform === 'IOS'?'BundleID:':'PackageName:'}</div>
                    </Col>
                    <Col style={Styles.dateilsRight}>{props.item.platform === 'IOS'?props.item.buildleID:props.item.packageName}</Col>
                </Row>
                <Row style={{ marginTop: '10px' }}>
                    <Col><div style={Styles.dateilsLeft}>最新版本:</div></Col>
                    <Col style={Styles.dateilsRight}>{props.item.platform === 'IOS'?props.item.latestApp.version+'(Build '+props.item.latestApp.bundleVersion+")":props.item.latestApp.versionName+'(Build '+props.item.latestApp.versionCode+")"}</Col>
                </Row>
                <Row style={{ marginTop: '10px' ,display:props.item.platform === 'IOS'?'':'none'}}>
                    <Col> <div style={Styles.dateilsLeft}>打包类型:</div></Col>
                    <Col style={Styles.dateilsRight}>{props.item.teamName!==null?'企业级':'非企业级' }</Col>
                </Row>
                <Row style={{ marginTop: '10px' }}>
                    <Col> <div style={Styles.dateilsLeft}>owner:</div></Col>
                    <Col style={Styles.dateilsRight}>{props.item.owner}</Col>
                </Row>
            </div>
        </Button>


    );

}
const Styles = {
    dateilsLeft: {
        fontSize: '14px',
        color: 'rgba(0, 0, 0, 0.45)',
        marginLeft: '30px',
        width: '80px',
        display:'flex',
        justifyContent: 'left',


    }, dateilsRight: {
        fontSize: '14px',
        color: 'rgba(0, 0, 0, 0.85)',
        marginLeft: '30px'
    },
}
export default DateilsItemPage